import { render, staticRenderFns } from "./GroupPostCount.vue?vue&type=template&id=da048ad0&scoped=true"
import script from "./GroupPostCount.vue?vue&type=script&lang=js"
export * from "./GroupPostCount.vue?vue&type=script&lang=js"
import style0 from "./GroupPostCount.vue?vue&type=style&index=0&id=da048ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da048ad0",
  null
  
)

export default component.exports